export default __webpack_public_path__ + "images/pdf_logo_90_f74fec03fa4a2f12893d1e77f3999927.png";